import React from 'react';
import BrandHeader from './BrandHeader';
import LegalFooter from './LegalFooter';

const MESSAGES = {
  expired: {
    title: 'This link has expired',
    body: 'Please contact Fair to request a fresh link.',
    retryLabel: null,
  },
  invalid_link: {
    title: "We couldn't find your details",
    body: 'Please contact Fair for help — they can send you a new link.',
    retryLabel: null,
  },
  upstream: {
    title: "We're having trouble loading your details",
    body: 'Please try again in a few minutes.',
    retryLabel: 'Try again',
  },
  unknown: {
    title: 'Something went wrong',
    body: 'Please try again, or contact Fair if this continues.',
    retryLabel: 'Try again',
  },
};

export default function ErrorScreen({ kind = 'unknown', supportEmail, onRetry }) {
  const msg = MESSAGES[kind] || MESSAGES.unknown;
  return (
    <div className="container">
      <BrandHeader />
      <div className="card stack">
        <span className="badge danger">Heads up</span>
        <h1 className="h1">{msg.title}</h1>
        <p>{msg.body}</p>
        {msg.retryLabel ? <button className="btn" onClick={onRetry}>{msg.retryLabel}</button> : null}
        {supportEmail ? <p className="small muted">Contact: <a className="link-action" href={`mailto:${supportEmail}`}>{supportEmail}</a></p> : null}
      </div>
      <LegalFooter />
    </div>
  );
}
